
import BlockType2Grid from '../1-10/block-type-2/BlockType2Grid.vue';
import BlockType3Grid from '../1-10/block-type-3/BlockType3Grid.vue';
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType113';
import sampleSize from 'lodash/sampleSize';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';

const defaultSettings = {
  icons: true,
  author: false,
  titleComment: true,
  channel: false,
  category: false,
  lead: false,
  publishDate: false,
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  components: {
    BlockType2Grid,
    BlockType3Grid,
  },
  data() {
    return {
      blockData: {
        items: [] as HeadlineWithRelatedArticles[],
        hasRandomItems: false,
      },
    };
  },
  mounted() {
    const count = this.isMobileView ? 2 : 3;
    const items = sampleSize(this.data.items, count);

    this.blockData = { ...this.data, items, hasRandomItems: true };
  },
});
